import {Component, Input, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {CustomerCommentDto} from "../../../model/dto/entity/customer-comment.dto";
import {MvsFormGroup} from "../../../../../core/shared/logic/form/mvs-form-group";
import {MvsFormDto} from "../../../../../core/shared/dto/form/dto/mvs-form.dto";
import {MvsFormFieldDto} from "../../../../../core/shared/dto/form/dto/mvs-form-field.dto";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {ConfirmationService} from "primeng/api";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {CustomerCommentService} from "../../../service/api/customer-comment.service";
import {CustomerService} from "../../../service/api/customer.service";
import {MvsFormControlService} from "../../../../../core/shared/form/service/mvs-form-control.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {Observable} from "rxjs";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {CustomerPhoneContactAvailabilityDto} from "../../../model/dto/entity/customer-phone-contact-availability.dto";
import {map} from "rxjs/operators";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'cr-customer-comments',
    templateUrl: './cr-customer-comments.component.html',
    standalone: false
})
export class CrCustomerCommentsComponent
    extends ObjectBaseComponent {

    @Input() customerObjectId: number;
    @Input() headline: string;

    dto: CustomerCommentDto;
    editComment: boolean = true;
    formGroup: MvsFormGroup | FormGroup;
    form: MvsFormDto;
    formFieldComment: MvsFormFieldDto;

    constructor(
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected customerCommentService: CustomerCommentService,
        protected customerService: CustomerService,
        protected formService: MvsFormControlService,
        protected override observerService: ObserverService) {

        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit(): void {
        if (this.customerObjectId && !this.objectIdentifier) {
            this.objectIdentifier = new ObjectIdentifier("cr.CustomerComment", 0);
        }

        super.ngOnInit();
    }

    getUpdateObservable(updateDto: CustomerCommentDto): Observable<DtoDetail> {

        updateDto.id = this.objectIdentifier.objectId;

        if (updateDto.id) {
            return this.customerCommentService.update(updateDto);
        } else {
            return this.customerCommentService.create(updateDto);
        }

    }

    updateObject(updateDto: CustomerCommentDto) {
        this.busy = true;
        this.getUpdateObservable(updateDto).subscribe((res: CustomerCommentDto) => {

            this.dto = res;
            this.form = this.dto.form;
            this.setFormGroup();
            this.messageService.showSuccessMessage('Comment','Comment gespeichert!!')
            this.busy = false;
        });
    }

    handleComment(dto: CustomerCommentDto | DtoDetail) {
        const updateDto = new CustomerPhoneContactAvailabilityDto();
        updateDto.comment = dto['comment'];

        this.updateObject(updateDto);

    }


    /**
     * Retrieve obeservable depending on the input.
     * @protected
     */
    protected getRetrieveObjectObservable(): Observable<any> {
        if (this.objectIdentifier && this.objectIdentifier.objectId) {
            // retrieve via ID
            return this.crudService.get(this.objectIdentifier.objectId, null, true);

        } else if (this.customerObjectId) {

            // retrieve via customer ID
            return this.customerCommentService.listByAttribute('customer', this.customerObjectId).pipe(
                map(value => {

                    const dto = <CustomerCommentDto>value.entries[0];
                    if (dto) {
                        dto.form = value.form;
                        this.form = value.form;
                        this.objectIdentifier = new ObjectIdentifier("cr.CustomerComment", dto.id);
                        return dto;
                    } else {
                        const createDto: CustomerCommentDto = new CustomerCommentDto();
                        createDto.customerDtoId = this.customerObjectId;
                        this.updateObject(createDto);
                        return null;
                    }



                }));

        } else {
            return this.crudService.get(this.objectIdentifier.objectId, null, true);
        }

    }

    ngOnChanges(changes: SimpleChanges): void {

        super.ngOnChanges(changes);

        if (!this.initialized) {
            return;
        }

        if (changes["customerObjectId"]) {
            this.refreshObject(false);
        }

    }

    setFormGroup() {

        // this.formFieldComment = { id: this.form.formFields['comment'].id, field : this.form.formFields['comment'], uiOutputControl: 'text'};
        this.formFieldComment = this.form?.getFormField("comment");

        this.formGroup = this.formService.buildFormGroup(this.form);
        this.formGroup.patchValue(this.dto);
    }

    handleEditComment() {
        this.editComment = !this.editComment;
    }

    onObjectChanged() {
        if (this.dto) {
            this.setFormGroup();
        }
    }

}
